import React, { useEffect, useState } from "react";
import NavBarDark from "../components/NAVBAR/NavBarDark";
import Footer from "../components/FOOTER/Footer";
import { Helmet } from "react-helmet";
import { FaMapMarkerAlt, FaCalendarAlt } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { fetch_event } from "../api/event";
import RSVPForm from "../components/RSVPForm";
import moment from "moment";

const EventDetails = (props) => {
  return (
    <div className="bg-light-green-100 md:h-auto relative overflow-hidden rounded-lg max-w-[595px] md:w-2/5 flex flex-col justify-center md:justify-start">
      {
        Boolean(props.event?.invitation_file?.length) && (
          <img 
            src={props.event?.invitation_file}
            className="w-full self-center rounded-lg" 
          />
        )
      }
      <p className="mt-6 text-[18px] font-sora font-semibold text-new-black-1000 text-center md:text-[18px] ">
        {props.event?.title ?? ''}
      </p>
      <div
        className="hidden sm:block"
      >
        {
          props.event?.schedules.map((item, index) => {
            return (
              <div
                className="border border-border m-5 p-[10px] rounded-md"
              >
                <p
                  className="font-sora font-semibold text-[14px] mb-[10px]"
                >
                  {item.label}
                </p>
                <div className=" items-center justify-center">
                  
                  <div>
                    <div
                      className="flex gap-2.5"
                    >
                      <div className="h-4 w-4 rounded-full center">
                        <FaCalendarAlt className="text-[12px] text-light-green-600" />
                      </div>
                      <p className="text-new-black-500 text-sm ">
                        {moment(item.date).format('DD MMM YYYY')} {moment(item.start_time, "HH:mm:ss").format("HH:mm A")} - {moment(item.end_time, "HH:mm:ss").format("HH:mm A")}
                      </p>
                    </div>
                    <div
                      className="flex gap-2.5 mt-[10px]"
                    >
                      <div className="h-4 w-4 rounded-full center">
                        <FaMapMarkerAlt className="text-sm text-light-green-600" />
                      </div>
                      <p className="text-new-black-500 text-sm ">
                        {
                          Boolean(item?.is_community_event) ? 
                          `${item?.location ?? ''} ${item?.city ?? ''} ${item?.state ?? ''}` :
                          `${item?.address_line_1 ?? ''} ${item?.address_line_2 ?? ''} ${item?.city ?? ''} ${item?.state ?? ''}`
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
      

    </div>
  )
}

const RSVPPage = () => {
  function getQueryParam(name, search) {
    const params = new URLSearchParams(search);
    return params.get(name);
  }

  const location = useLocation();
  const event_id = getQueryParam('event_id', location.search);

  // const { event_id } = useParams();
  // console.log(event_id);

  const [event, setEvent] = useState(null)
  const [loading, setLoading] = useState(false)
  const [dataFetchFailed, setDataFetchFailed] = useState(false)
  const [errMsg, setErrMsg] = useState('')

  
  useEffect(() => {
    fetchEventData()
  }, [])

  const fetchEventData = async () => {
    try {
      setLoading(true)
      
      const params = {
        event_id: event_id ?? '',
      }

      const res = await fetch_event(params)
      const response = await res.json()
      console.log('event', response)
      setLoading(false)
      if (res.ok) {
        setDataFetchFailed(false)
        setEvent(response.data)
        console.log('event', response.data)
      } else {
        setDataFetchFailed(true)
        setErrMsg(response?.message)
      }

    } catch (error) {
      setDataFetchFailed(true)
      setErrMsg("Oops... Something went wrong")
    }
  } 
  

  return (
    <>
      <Helmet>
        <title>
          RSVP Now - Venco Events | All-in-one Community Management
          Software
        </title>
        <meta
          property="og:title"
          content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
        />
        <meta
          name="twitter:title"
          content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
        />
      </Helmet>
      <NavBarDark />
      <section className="container mx-auto my-10 p-4">
        <div 
          className="flex flex-col md:flex-row gap-7 h-full  xl:max-w-[1328px] xl:mx-auto"
        >
          {/* Form Image Section */}
          <EventDetails 
            event={event}
          />
          <RSVPForm 
            event={event}
            eventID={event_id}
          />
        </div>
      </section>
      
      <Footer 
        
      />
    </>
  );
};

export default RSVPPage;
